import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2';
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useParams } from "react-router-dom";
import ReactPlayer from 'react-player';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './matchcss.css';

const Choice = (props) => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                accept: "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                Authorization: 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios.get(url, {
                headers: headerss,
                params: {
                    courseId: params['courseid'],
                }
            }).then(res => {
                if (res.data.success) {
                    setSubjectName(
                        res.data.data.subjects[params.subjectid - 1].subjectName +
                        " - " +
                        res.data.data.subjects[params.subjectid - 1].subjectDesc
                    );
                }
            });
        } catch (err) { }
    };

    const customAudioStyle = `
    .rhap_volume-controls,
    .rhap_additional-controls,
    .rhap_repeat-button,
    .rhap_skip-button,
    .rhap_rewind-button,
    .rhap_forward-button,
    .rhap_volume-button,
    .rhap_time {
        display: none !important;
    }

    .choice-page {
        width: 100%;
    }

    .choice-title {
        font-size: 18px;
    }

    .choice-question-text {
        font-size: 30px;
        color: black;
        word-break: break-word;
        overflow-wrap: anywhere;
        line-height: 1.35;
    }

    .answers-grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
        text-align: center;
        width: 100%;
    }

    .option-box {
        border: 2px solid #7ac1f7ff;
        border-radius: 10px;
        padding: 10px;
        transition: 0.2s;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 200px;
        height: 200px;
        max-width: 100%;
        box-shadow: 0 0 8px rgba(0,0,0,0.05);
        background: white;
        box-sizing: border-box;
    }

    .option-box.active {
        border-color: #007bff;
        background-color: #e6f0ff;
        box-shadow: 0 0 10px rgba(0, 123, 255, 0.4);
    }

    .choice-option-inner {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        min-width: 0;
    }

    .choice-media-wrap {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .choice-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .choice-text-answer {
        margin-bottom: 10px;
        font-weight: bold;
        word-break: break-word;
        overflow-wrap: anywhere;
        line-height: 1.35;
    }

    .custom-player {
        margin: auto;
        width: 60px !important;
        height: 60px !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;
    }

    .custom-player .rhap_play-pause-button {
        font-size: 40px !important;
        color: blue !important;
    }

    .custom-player .rhap_progress-section {
        display: none !important;
    }

    .choice-submit-wrap {
        display: flex;
        justify-content: center;
    }

    @media (max-width: 992px) {
        .answers-grid {
            gap: 14px;
        }

        .option-box {
            width: 170px;
            height: 170px;
        }

        .choice-question-text {
            font-size: 24px;
        }
    }

    @media (max-width: 768px) {
        .choice-title {
            font-size: 14px !important;
        }

        .choice-question-text {
            font-size: 18px !important;
        }

        .answers-grid {
            gap: 10px;
            padding-bottom: 60px;
        }

        .option-box {
            width: 145px;
            height: 165px;
            padding: 8px !important;
        }

        .custom-player {
            width: 48px !important;
            height: 48px !important;
        }

        .custom-player .rhap_play-pause-button {
            font-size: 32px !important;
        }

        .choice-submit-wrap {
            padding: 0 6px;
        }

        .choice-submit-wrap .save-btn {
            width: 100%;
            max-width: 360px;
        }

        .answers-grid::after {
            content: "";
            display: block;
            height: 40px;
            width: 100%;
        }
    }

    @media (max-width: 480px) {
        .answers-grid {
            gap: 8px;
        }

        .option-box {
            width: calc(50vw - 20px);
            height: 145px;
        }

        .choice-question-text {
            font-size: 16px !important;
        }

        .choice-text-answer {
            font-size: 13px;
        }
    }
    `;

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                accept: "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                Authorization: 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data.success) {
                    props.playSuccessSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        timer: 3000,
                    }).then(() => {
                        window.location.href =
                            "/user/course/question/" + params['courseid'] + "/" +
                            params.subjectid + "/" +
                            (Number(params.id) + 1);
                    });
                } else {
                    props.playErrorSound?.();
                    Swal.fire({
                        title: "Hatalı cevap",
                        text: props.data.notfyText,
                        icon: "error",
                    }).then(() => {
                        window.location.href =
                            "/user/course/question/" + params['courseid'] + "/" +
                            params.subjectid + "/" +
                            (Number(params.id) + 1);
                    });
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    };

    const answerChoiceHandle = (e) => {
        e.preventDefault();

        if (selectedAnswer === null) {
            Swal.fire({
                title: "Uyarı",
                text: "Lütfen bir seçenek seçin.",
                icon: "warning",
                confirmButtonText: "Tamam",
            });
            return;
        }

        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY) || "0", 10);
        const correctAnswer = Number(props.data.answer);

        if (attempt === 0 || attempt === 1) {
            if (selectedAnswer === correctAnswer) {
                Request(selectedAnswer);
            } else {
                localStorage.setItem(ATTEMPT_KEY, String(attempt + 1));
                props.playErrorSound?.();
                Swal.fire({
                    title: attempt === 0 ? "Tekrar Deneyiniz!" : "Son bir kez deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        Request(selectedAnswer);
    };

    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }
    }, [ATTEMPT_KEY]);

    useEffect(() => {
        getSubject();
        const questionn = JSON.parse(props.data.contentStr);
        setQuestion(questionn);
        setQuestionTitle(questionn.text.split('__')[0]);
        setQuestionText(questionn.text.split('__')[1]);
        setAnswers(JSON.parse(props.data.detail));
    }, []);

    return (
        <div className="choice-page">
            <style>{customAudioStyle}</style>

            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>

            <br />

            <div style={{ textAlign: "center" }}>
                <QuestionContents question={question} />
                {!(question?.type === "sound" || question?.type === "video" || question?.type === "image" || question?.type === "image_sound") && (
                    <>
                        <br />
                        <br />
                    </>
                )}

                <b className="choice-title">
                    {questionTitle}
                </b>

                <br />

                {questionText ? (
                    <div>
                        <br />
                        <b className="choice-question-text">
                            {questionText}
                        </b>
                    </div>
                ) : null}

                <br />
            </div>

            <form onSubmit={answerChoiceHandle}>
                <div className="answers-grid">
                    {answers.map((dt, index) => (
                        <div
                            key={dt.id}
                            onClick={() => setSelectedAnswer(index)}
                            className={`option-box ${selectedAnswer === index ? "active" : ""}`}
                        >
                            <div className="choice-option-inner">
                                {(dt.photo || dt.video || dt.sound) ? (
                                    <div className="choice-media-wrap">
                                        {dt.photo && (
                                            <img
                                                src={dt.photo}
                                                alt="choice"
                                                className="choice-image"
                                            />
                                        )}
                                        {dt.video && (
                                            <ReactPlayer
                                                url={dt.video}
                                                width="100%"
                                                height="100%"
                                                controls
                                            />
                                        )}
                                        {dt.sound && (
                                            <AudioPlayer src={dt.sound} className="custom-player" />
                                        )}
                                    </div>
                                ) : (
                                    <div className="choice-text-answer">{dt.service}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <br />

                {!props.answered && (
                    <div className="choice-submit-wrap">
                        <button type="submit" className="save-btn">
                            {t("saveAndContinue")}
                        </button>
                    </div>
                )}
            </form>
        </div>
    );
};

export default Choice;